






































import CommonBase from "../CommonBase";
import {Component, Emit, Inject, Prop} from "vue-property-decorator";
import PhoneAddIcon from "../PhoneAddIcon.vue";
import PersonMarker from "../PersonMarker.vue";
import DeviceType from "../DeviceType.vue";
import Api from "./Api";
import {PhoneNumber} from "../../modules/models";
import rd from "@/modules/vRoutedefs";

// Gives user the choice of what signup registration method he wishes to use.
@Component({
    components: {
        "at-phone-add-icon": PhoneAddIcon,
        "at-person-marker": PersonMarker,
        "at-devicetype": DeviceType,
    }
})
export default class SignupMethodChoice extends CommonBase {
    @Inject()
    api!: Api;
    @Prop()
    phone!: PhoneNumber;
    @Prop({default: ""})
    redir!: string;

    get qrInfoTo() {
        return {name: rd.login.signup.qr.info.name, params: {countrycode: ""+this.phone.countrycode, number: ""+this.phone.number}, query: {redir: this.redir}};
    }

    get unverifiedSignupTo() {
        return {name: rd.login.signupunverified.name, query: {redir: this.redir}};
    }

    get loginTo() {
        return {name: rd.public.name, query: {redir: this.redir}};
    }

    qrConnectAvailable = false;

    async loadQrConnectAvailable() {
        this.qrConnectAvailable = await this.api.qrConnectAvailable();
        if(!this.qrConnectAvailable) {
            this.snackMsg(`Qr kode registrering ikke tilgjengelig for øyeblikket`);
        }
    }

    created() {
        this.loadQrConnectAvailable();
    }

    @Emit("at-snack")
    snackMsg(msg: string) {}
}
